import IconButton from 'components/common/IconButton';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { Col, Form, Row, Button } from 'react-bootstrap';

const CustomersTableHeader = ({ selectedRowIds, onSearch }) => {
 const [searchTerm, setSearchTerm] = useState('');

 const handleSearchChange = event => {
  const term = event.target.value;
  setSearchTerm(term);
  onSearch(term); // Llama a la función onSearch y pasa el término de búsqueda
 };
 return (
  <Row className="flex-between-center align-items-center">
   <Col xs={12} sm={4} className="pe-0">
    <h5 className="fs-0 mb-0 text-nowrap py-2 py-xl-0">Orders</h5>
   </Col>
   <Col xs={12} sm={8} className="ms-auto text-end ps-0 d-flex align-items-center">
    <Form.Control
     type="text"
     value={searchTerm}
     onChange={handleSearchChange}
     placeholder="Buscar ordenes/status/cliente/id/vendedor"
     style={{ height: '30px', fontSize: '0.875rem', borderRadius: '4px' }}
     className="form-control-sm me-2"
    />
    {Object.keys(selectedRowIds).length > 0 ? (
     <div className="d-flex">
      <Form.Select size="sm" aria-label="Bulk actions" className="me-2">
       <option>Bulk Actions</option>
       <option value="refund">Refund</option>
       <option value="delete">Delete</option>
       <option value="archive">Archive</option>
      </Form.Select>
      <Button type="button" variant="falcon-default" size="sm">
       Apply
      </Button>
     </div>
    ) : (
     <div id="orders-actions" className="d-flex">
      <IconButton variant="falcon-default" size="sm" icon="plus" transform="shrink-3" className="me-2">
       <span className="d-none d-sm-inline-block ms-1">New</span>
      </IconButton>
      <IconButton variant="falcon-default" size="sm" icon="filter" transform="shrink-3" className="me-2">
       <span className="d-none d-sm-inline-block ms-1">Filtrar</span>
      </IconButton>
      <IconButton variant="falcon-default" size="sm" icon="external-link-alt" transform="shrink-3">
       <span className="d-none d-sm-inline-block ms-1">Export</span>
      </IconButton>
     </div>
    )}
   </Col>
  </Row>
 );
};

CustomersTableHeader.propTypes = {
 selectedRowIds: PropTypes.object,
 onSearch: PropTypes.func.isRequired
};

export default CustomersTableHeader;
